/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const PlatformRights = {
    PlatformAiUpsertRetrigger: 'platform:ai_upsert:retrigger',
    PlatformDocumentProcessingManage: 'platform:document_processing:manage',
    PlatformTermsAndConditionsDelete: 'platform:terms_and_conditions:delete',
    PlatformUserRolesRead: 'platform:user_roles:read',
    PlatformUserRolesAssign: 'platform:user_roles:assign',
    PlatformUserRolesDelete: 'platform:user_roles:delete',
    PlatformPolicyTemplateRead: 'platform:policy_template:read',
    PlatformPolicyTemplateCreate: 'platform:policy_template:create',
    PlatformPolicyTemplateEdit: 'platform:policy_template:edit',
    PlatformNotificationTypesRead: 'platform:notification_types:read',
    PlatformNotificationTypesUpdate: 'platform:notification_types:update',
    PlatformOrganizationsCreate: 'platform:organizations:create',
    PlatformOrganizationUsersCreate: 'platform:organization_users:create',
    PlatformOrganizationsUsersDelete: 'platform:organizations:users:delete',
    PlatformOrganizationUsersResetEmail: 'platform:organization:users:reset_email',
    PlatformOrganizationsRead: 'platform:organizations:read',
    PlatformOrganizationsDelete: 'platform:organizations:delete',
    PlatformOrganizationsFrameworksRead: 'platform:organizations:frameworks:read',
    PlatformOrganizationsMetricsRead: 'platform:organizations:metrics:read',
    PlatformOrganizationsAiQuotaFullAccess: 'platform:organizations:ai_quota:full_access',
    PlatformFrameworksRead: 'platform:frameworks:read',
    PlatformFrameworksCreate: 'platform:frameworks:create',
    PlatformFrameworksLink: 'platform:frameworks:link',
    PlatformPolicyDelete: 'platform:policy:delete',
    PlatformOrganizationsFullAccess: 'platform:organizations:full_access',
    PlatformProjectsFullAccess: 'platform:projects:full_access',
    PlatformProjectsImport: 'platform:projects:import',
} as const;

export type PlatformRights = typeof PlatformRights[keyof typeof PlatformRights];



